import React, { useState } from 'react'
import useData from '../hooks/useData'
import Loading from './Loading'
import QueryBadge from './QueryBadge'
import { format, subDays } from 'date-fns'

const nbDays = 90
const byImpression = (a, b) => {
    return (a.impressions < b.impressions && 1) || -1
}
const byClick = (a, b) => {
    return (a.clicks < b.clicks && 1) || -1
}
const mergePages = (acc, i) => {
    let c = acc.find((c) => c.keys[1] === i.keys[1])
    if (c) {
        c = {
            ...i,
            clicks: parseInt(i.clicks) + parseInt(c.clicks),
            impressions: parseInt(i.impressions) + parseInt(c.impressions),
            position_array: [...c.position_array, i.position || 0],
        }
    } else {
        acc.push({ ...i, position_array: [i.position || 0] })
    }
    return acc
}

const ArticleQueries = (props) => {
    const id = props.id || (props.match && props.match.params && props.match.params.id) || false
    const [date, setDate] = useState([subDays(new Date(), nbDays), new Date()])

    const articleData = useData({ url: 'article/' + id, transform: (data) => ({ ...data, resources: (data.resources && JSON.parse(data.resources)) || null }) })
    const siteArray = useData('site')
    const siteData = { ...siteArray, data: (siteArray.data && articleData.data && siteArray.data.find((s) => s.id == articleData.data.site_id)) || undefined }

    const SCDataCurrent = useData(
        articleData.isReady &&
            siteData.isReady &&
            'google/search_console?dimensions[0]=page&dimensions[1]=query&site_id=' +
                articleData.data.site_id +
                '&url=' +
                'https://' +
                siteData.data.url +
                '/' +
                ((articleData.data.permalink !== 'homepage' && articleData.data.permalink) || '') +
                '&start_date=' +
                format(date[0], 'yyyy-MM-dd') +
                '&end_date=' +
                format(date[1], 'yyyy-MM-dd'),
        (r) => (r && r.filter((i) => i.position < 30)) || null,
        [articleData.isReady]
    )
    const SCDataCurrentAmp = useData(
        articleData.isReady &&
            siteData.isReady &&
            'google/search_console?dimensions[0]=page&dimensions[1]=query&site_id=' +
                articleData.data.site_id +
                '&url=' +
                'https://' +
                siteData.data.url +
                '/' +
                ((articleData.data.permalink !== 'homepage' && articleData.data.permalink) || '') +
                encodeURI('?amp=1') +
                '&start_date=' +
                format(date[0], 'yyyy-MM-dd') +
                '&end_date=' +
                format(date[1], 'yyyy-MM-dd'),
        (r) => (r && r.filter((i) => i.position < 30)) || null,
        [articleData.isReady]
    )
    const SCDataOld = useData(
        articleData.isReady &&
            articleData.data.old_permalink &&
            siteData.isReady &&
            'google/search_console?dimensions[0]=page&dimensions[1]=query&site_id=' +
                articleData.data.site_id +
                '&url=' +
                'https://' +
                siteData.data.url +
                '/' +
                articleData.data.old_permalink +
                '&start_date=' +
                format(date[0], 'yyyy-MM-dd') +
                '&end_date=' +
                format(date[1], 'yyyy-MM-dd'),
        (r) => (r && r.filter((i) => i.position < 30)) || null,
        [articleData.isReady]
    )
    const SCDataOldAmp = useData(
        articleData.isReady &&
            articleData.data.old_permalink &&
            siteData.isReady &&
            'google/search_console?dimensions[0]=page&dimensions[1]=query&site_id=' +
                articleData.data.site_id +
                '&url=' +
                'https://' +
                siteData.data.url +
                '/' +
                articleData.data.old_permalink +
                encodeURI('?amp') +
                '&start_date=' +
                format(date[0], 'yyyy-MM-dd') +
                '&end_date=' +
                format(date[1], 'yyyy-MM-dd'),
        (r) => (r && r.filter((i) => i.position < 30)) || null,
        [articleData.isReady]
    )
    // console.log({SCDataCurrent})
    const SCData =
        (SCDataCurrent.isReady &&
            SCDataCurrentAmp.isReady &&
            SCDataOld.isReady &&
            SCDataOldAmp.isReady && [...SCDataCurrent.data, ...SCDataCurrentAmp.data, ...SCDataOld.data, ...SCDataOldAmp.data]) ||
        []
    const isLoading = SCDataCurrent.isLoading || SCDataCurrentAmp.isLoading || SCDataOld.isLoading || SCDataOldAmp.isLoading
    // console.log(SCData.length)
    // console.log({SCData})
    let SCDataClicks = [...SCData]
    SCDataClicks = SCDataClicks.filter((i) => i.clicks)
        .reduce(mergePages, [])
        .sort(byClick)
    // console.log({SCData})
    let SCDataHighImpressionsNoClicks = [...SCData]
    SCDataHighImpressionsNoClicks = SCDataHighImpressionsNoClicks.filter((i) => !i.clicks && i.impressions > 30)
        .reduce(mergePages, [])
        .sort(byImpression)

    return (
        <>
            {(!isLoading && (
                <>
                    {(SCDataClicks.length && (
                        <>
                            <h2>
                                Queries resulting in clicks <small className="text-muted">-{nbDays} days</small>
                            </h2>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>URL</th>
                                        <th>Query</th>
                                        <th>Clicks</th>
                                        <th>Impressions</th>
                                        <th>CTR</th>
                                        <th>Position</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {SCDataClicks.map((i) => (
                                        <tr key={`${i.keys[1]}`}>
                                            <td>
                                                <span className="text-muted">{i.keys[0]}</span>
                                            </td>
                                            <td>
                                                <QueryBadge>{i.keys[1]}</QueryBadge>
                                            </td>
                                            <td>{i.clicks}</td>
                                            <td>{i.impressions}</td>
                                            <td>{((i.clicks / i.impressions) * 100).toFixed()}</td>
                                            <td>
                                                {(
                                                    i.position_array.reduce((acc, position) => {
                                                        acc += position
                                                        return acc
                                                    }, 0) / i.position_array.length
                                                ).toFixed(2)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    )) ||
                        null}

                    {(SCDataHighImpressionsNoClicks.length && (
                        <>
                            <h2>
                                Impressions but no clicks <small className="text-muted">-{nbDays} days</small>
                            </h2>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>URL</th>
                                        <th>Query</th>
                                        <th>Clicks</th>
                                        <th>Impressions</th>
                                        <th>CTR</th>
                                        <th>Position</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {SCDataHighImpressionsNoClicks.map((i) => (
                                        <tr key={`high-impression-no-clicks${i.keys[1]}`}>
                                            <td>
                                                <span className="text-muted">{i.keys[0]}</span>
                                            </td>
                                            <td>
                                                <QueryBadge>{i.keys[1]}</QueryBadge>
                                            </td>
                                            <td>{i.clicks}</td>
                                            <td>{i.impressions}</td>
                                            <td>{((i.clicks / i.impressions) * 100).toFixed()}</td>
                                            <td>
                                                {(
                                                    i.position_array &&
                                                    i.position_array.reduce((acc, position) => {
                                                        acc += position
                                                        return acc
                                                    }, 0) / i.position_array.length
                                                ).toFixed(2)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    )) ||
                        null}
                </>
            )) || <Loading text="Fetching data from Google Search Console API" />}
        </>
    )
}

export default ArticleQueries
